module.exports = __webpack_public_path__ + "static/media/user-contribution.2fe2f5cd.png";